module.exports = "/fonts/FiraSans-Italic.ttf";